"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _withDragAndDrop = _interopRequireDefault(require("./withDragAndDrop"));

var _default = _withDragAndDrop.default;
exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../~/react-big-calendar/lib/addons/dragAndDrop/index.js
// module id = 2984
// module chunks = 121